import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext, useContextWithValidation } from '@adsk/alloy-react-context';
import { PRODUCT_IDS } from './consts';
/**
 * Context for current product ID.
 */
const CurrentProductIdContext = getOrCreateGlobalContext(CONTEXT_NAMES.CurrentProductIdContext);
const useCurrentProductIdContext = () => useContextWithValidation(CurrentProductIdContext, {
  hook: 'useCurrentProductIdContext',
  provider: 'CurrentProductIdProvider'
});
export const useCurrentProductId = () => {
  const currentProductIdContext = useCurrentProductIdContext();
  return currentProductIdContext === null || currentProductIdContext === void 0 ? void 0 : currentProductIdContext.productId;
};
export const CurrentProductIdProvider = _ref => {
  let {
    children,
    productId
  } = _ref;
  const value = useMemo(() => {
    return {
      productId
    };
  }, [productId]);
  return /*#__PURE__*/React.createElement(CurrentProductIdContext.Provider, {
    value: value
  }, children);
};
CurrentProductIdProvider.displayName = 'CurrentProductIdProvider';
CurrentProductIdProvider.propTypes = {
  /** Nodes with access to context */
  children: PropTypes.node,
  /** The product ID */
  productId: PropTypes.oneOf(Object.values(PRODUCT_IDS))
};
//# sourceMappingURL=CurrentProductIdContext.js.map